import { HttpParamsHelpersService } from '@zaoblako/web/core/services/http-params-helpers.service';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';
import type { FileFindManyQueryInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find-many-query.dto';
import type { FilePageInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-page.dto';
import type { TaskFormInterface } from '@zaoblako/shared/modules/task/dtos/task-form.dto';
import type { UniversalInvoiceParsedQueryInterface } from '@zaoblako/shared/modules/task/dtos/brs-file-parser/universal-invoice-parsed-query.dto';
import type { CommentaryFormInterface } from '@zaoblako/shared/modules/messenger/dtos/commentary/commentary-form.dto';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  public constructor(
    private readonly http: HttpClient,
    private readonly httpParamsHelpersService: HttpParamsHelpersService
  ) {}

  public findMany(query?: FileFindManyQueryInterface): Observable<FilePageInterface> {
    return this.http.get<FilePageInterface>('/basis/storage/file', {
      params: query ? this.httpParamsHelpersService.objectToHttpParams(query) : {}
    });
  }

  public analyzeOne(id: string): Observable<FileFindInterface> {
    return this.http.get<FileFindInterface>(`/basis/storage/file/${id}/analyze`);
  }

  public upload(files: File[], queryParams?: { scaleTo: number }): Observable<FileFindInterface[]> {
    if (!files?.length) {
      return of([]);
    }

    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i], files[i].name);
    }
    return this.http.post<FileFindInterface[]>('/basis/storage/file', formData, { params: queryParams });
  }

  public getPastedImage(event: ClipboardEvent): Observable<FileFindInterface | null> {
    const images = this.getImageFromEvent(event);

    if (images) {
      event.preventDefault();
      return this.upload(images).pipe(map((createdImages) => createdImages[0]));
    }

    return of(null);
  }

  public parseUniversalInvoice(
    uuid: string,
    queryParams?: UniversalInvoiceParsedQueryInterface
  ): Observable<TaskFormInterface> {
    return this.http.get<TaskFormInterface>(`/basis/storage/file/${uuid}/parse-universal-invoice`, {
      params: queryParams as any
    });
  }

  public transcriptAudio(id: string): Observable<CommentaryFormInterface> {
    return this.http.get<TaskFormInterface>(`/basis/storage/file/${id}/transcript-audio`);
  }

  private getImageFromEvent(event: ClipboardEvent): File[] | null {
    const files: File[] = event.clipboardData?.files as unknown as File[];
    return files && files.length === 1 && files[0].type.search(/^image\//i) === 0 ? files : null;
  }
}
